import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';

import Button from '../../buttons/Button';
import Body from '../../partials/Body';

import styles from '../../../../styles/items/games/tinder.module.scss';

interface TinderGameItemProps {
    game: TinderGame;
    className?: string | null;
}

function TinderGameItem({ game, className = null }: TinderGameItemProps) {
    const { url, title } = game || {};

    return (
        <div className={classNames([styles.container, className])}>
            <div className={styles.inner}>
                <Button href={url} className={styles.button}>
                    <span className={styles.content}>
                        <Body tag="span" body={title} />
                    </span>
                    <span className={styles.arrow}>
                        <FontAwesomeIcon icon={faChevronRight} />
                    </span>
                </Button>
            </div>
        </div>
    );
}

export default TinderGameItem;
